import { connect } from 'react-redux';

import Preview from './Preview.js';

const mapStateToProps = (state) => {
	return {
		user: state.api.user
	};
};

const ConnectedPreview = connect(mapStateToProps, null)(Preview);

export default ConnectedPreview;
